/**
 * Small helper for the marketing site to know whether the user is
 * currently signed in to the Careers module. Reads Supabase's own
 * localStorage key without loading the Supabase JS SDK on the marketing
 * pages (keeps the marketing bundle tiny).
 */
const STORAGE_KEY = 'euroelite-careers-auth';

export function isCareersSignedIn() {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    const expiresAt = parsed?.expires_at || parsed?.currentSession?.expires_at;
    if (!expiresAt) return Boolean(parsed?.access_token || parsed?.currentSession?.access_token);
    return Number(expiresAt) * 1000 > Date.now();
  } catch (_) {
    return false;
  }
}
